import AccountMenu from "./AccountMenu";
import React, { useEffect, useState } from "react";
import {
  clearSession,
  getAdminPermission,
  getSession,
  validSession,
} from "../../bandung";
import { useNavigate } from "react-router-dom";
import AccountMenuButton from "./AccountMenuButton";
import { PersonAddRounded } from "@mui/icons-material";
import { getSessionImageEndPoint } from "../../api/session";
import { Box } from "@mui/material";

const AccountMenuComponent = ({ ...props }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [profileImage, setProfileImage] = useState(null);
  const navigate = useNavigate();

  const isValidSession = validSession();
  const isAdminPermission = getAdminPermission();

  useEffect(() => {
    setProfileImage(getSessionImageEndPoint(getSession()?.userEntityId));
  }, []);

  const handleSignin = () => {
    setAnchorEl(null);
    navigate("/signin");
  };

  const handleSignout = () => {
    clearSession();
    setAnchorEl(null);
    navigate("/signin");
  };

  const handleLinkClick = () => handleMenuClose();

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return isValidSession ? (
    <>
      <AccountMenuButton
        label={getSession().firstName ?? ""}
        avatarImage={<Box component="img" src={profileImage} />}
        isDropdown={true}
        onClick={handleMenuClick}
      />
      <AccountMenu
        anchorEl={anchorEl}
        onMenuClose={handleMenuClose}
        isAdminPermission={isAdminPermission}
        onSignoutClicked={handleSignout}
        onLinkClicked={handleLinkClick}
        {...props}
      />
    </>
  ) : (
    <AccountMenuButton
      label="Sign in"
      avatarImage={
        <PersonAddRounded fontSize="medium" style={{ paddingRight: 3 }} />
      }
      isDropdown={false}
      onClick={handleSignin}
    />
  );
};

export default AccountMenuComponent;
